var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31_25683",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.9272,
    y: 15.9272,
    width: 34.1455,
    height: 34.1455,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31_25683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6179 44.3818C20.8354 44.3818 20.1656 44.1032 19.6083 43.546C19.0511 42.9887 18.7725 42.3189 18.7725 41.5364V24.4636C18.7725 23.6811 19.0511 23.0113 19.6083 22.454C20.1656 21.8968 20.8354 21.6182 21.6179 21.6182H35.9875C35.8926 22.0924 35.8452 22.5667 35.8452 23.0409C35.8452 23.5151 35.8926 23.9894 35.9875 24.4636H21.6179L32.9998 31.5773L38.1927 28.3406C38.5247 28.6488 38.8863 28.9156 39.2775 29.1408C39.6688 29.3661 40.0778 29.5617 40.5047 29.7277L32.9998 34.4227L21.6179 27.3091V41.5364H44.3816V30.0123C44.927 29.8937 45.4368 29.7277 45.911 29.5143C46.3853 29.3009 46.8239 29.0401 47.2271 28.7318V41.5364C47.2271 42.3189 46.9484 42.9887 46.3912 43.546C45.834 44.1032 45.1641 44.3818 44.3816 44.3818H21.6179ZM42.9589 27.3091C41.7733 27.3091 40.7655 26.8941 39.9356 26.0642C39.1056 25.2343 38.6907 24.2265 38.6907 23.0409C38.6907 21.8553 39.1056 20.8475 39.9356 20.0176C40.7655 19.1877 41.7733 18.7727 42.9589 18.7727C44.1445 18.7727 45.1522 19.1877 45.9822 20.0176C46.8121 20.8475 47.2271 21.8553 47.2271 23.0409C47.2271 24.2265 46.8121 25.2343 45.9822 26.0642C45.1522 26.8941 44.1445 27.3091 42.9589 27.3091Z",
    fill: "#4928FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.09f9102d07ea2b02636526fa0f4862a0.svg";
export { ForwardRef as ReactComponent };